import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getAuthzCatalogue } from '@/api'
import {
  catalogueFrom,
  catalogueLang,
  type CatalogueLang,
} from '@/lib/authz/catalogue'
import { getApiErrorStatus } from '@/utils/apiError'

// Hors de `['authz', oid]` : les écritures des rôles et des accès invalident cette clé, pas le catalogue.
export const authzCatalogueQueryKey = (lang: CatalogueLang) =>
  ['authz-catalogue', lang] as const

/**
 * Le catalogue des droits et ses libellés, servis par la gateway (`GET /authz/catalogue`) dans la langue
 * d'i18next : chargé une fois par session et par langue. Fichier à part de `use-authz` : `useRights`, que
 * tous les écrans importent, s'en sert.
 */
export const useAuthzCatalogue = (enabled = true) => {
  const { i18n } = useTranslation()
  const lang = catalogueLang(i18n?.language)
  return useQuery({
    queryKey: authzCatalogueQueryKey(lang),
    queryFn: async () => catalogueFrom(await getAuthzCatalogue({ lang })),
    enabled,
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: (failureCount, error) => {
      const status = getApiErrorStatus(error)
      return (status === undefined || status >= 500) && failureCount < 2
    },
  })
}
